import React from 'react';
import Title from '../Dashboard/Title';
import { useDispatch, useSelector } from 'react-redux';
import { renderElementLC } from '../GuttmanChart/Filter';
import TableGuttmanChart from './Table';
import { useEffect } from 'react';
import { updateGroupMarkingStudent } from '../../../../../../store/actions/class-marking.actions';
import MarkingUtils from '../../../../../../utils/marking.utils';

const GroupMarking = ({ isLoading }) => {
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {});
  const marking = currentCurriculum?.marking || [];
  const minMarking = marking?.find((m) => m?.minValue);
  const maxMarking = marking?.find((m) => m?.maxValue);
  const completed = 'completedTeacher';
  const completedType = 'completedTeacherValue';
  const lcIds = useSelector((state) => state?.classMarking?.dashboard?.lcIds || []);
  const ulData = useSelector((state) => state?.class?.unitOfLearning || {});
  const dispatch = useDispatch();

  const ullcs = useSelector((state) =>
    JSON.parse(
      JSON.stringify(
        state?.class?.unitOfLearning?.lcs
          .filter((lc) => lcIds.includes(lc._id))
          .map((lc) => {
            return {
              ...lc,
              curriculumelements: renderElementLC(lc, currentCurriculum)
            };
          }) || []
      )
    )
  );
  const ulstudents = useSelector((state) => JSON.parse(JSON.stringify(state?.classMarking?.students || [])));
  const loading = useSelector((state) => state?.classMarking?.studentsLoading);

  const [students, setStudents] = React.useState(ulstudents);

  const onMarking = (maxLevel) => {
    if (ulData.status === 'active') {
      const newLCS = students.map((student) => {
        if (student._id === maxLevel.studentId) {
          const lcs = (student.lcs || []).map((lc) => {
            if (lc._id === maxLevel.lcId) {
              const granularSteps = MarkingUtils.setMarking(
                currentCurriculum.levels,
                lc.granularSteps,
                minMarking._id,
                maxMarking._id,
                completed,
                maxLevel
              );

              return {
                ...lc,
                granularSteps
              };
            }
            return lc;
          });

          return {
            ...student,
            lcs
          };
        }
        return student;
      });
      dispatch(updateGroupMarkingStudent(maxLevel));
      setStudents(newLCS);
    }
  };

  useEffect(() => {
    if (ulstudents.length > 0) {
      setStudents(ulstudents);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ulstudents.length]);

  return (
    <>
      <div className='absolute left-0px right-0px -top-1px h-14'>
        <Title isLoading={isLoading} />
      </div>
      <div className='absolute left-0px right-0 bottom-0 top-14 bg-background'>
        <TableGuttmanChart
          loading={loading}
          lcs={ullcs}
          completedType={completedType}
          completed={completed}
          onMarking={onMarking}
          minMarking={minMarking}
          maxMarking={maxMarking}
          marking={marking}
          students={students.map((student) => {
            const studentLcs = student?.lcs
              ?.filter((lc) => lcIds.includes(lc._id))
              ?.map((lc) => {
                const granularSteps = lc.granularSteps.filter((gs) => gs.isLevel);
                return {
                  ...lc,
                  granularSteps,
                  completedTeacherValue: granularSteps?.reduce(
                    (acc, step) => acc + step?.completedTeacherValue,
                    -1
                  ),
                  completedStudentValue: granularSteps?.reduce(
                    (acc, step) => acc + step?.completedStudentValue,
                    -1
                  ),
                  curriculumelements: renderElementLC(lc, currentCurriculum)
                };
              });

            return {
              ...student,
              lcs: studentLcs,
              completedTeacherValue: studentLcs?.reduce((acc, step) => acc + step?.[completedType], -1),
              completedStudentValue: studentLcs?.reduce((acc, step) => acc + step?.[completedType], -1),
              [completedType]: studentLcs?.reduce((acc, step) => acc + step?.[completedType], -1)
            };
          })}
        />
      </div>
    </>
  );
};

export default GroupMarking;
